import api from "../api";

export const getSubcategories = async () => {
  const res = await api.get("/subcategories");
  return res.data;
};

export const createSubcategory = async (data) => {
  const res = await api.post("/subcategories", data);
  return res.data;
};

export const updateSubcategory = async (id, data) => {
  const res = await api.put(`/subcategories/${id}`, data);
  return res.data;
};

export const deleteSubcategory = async (id) => {
  await api.delete(`/subcategories/${id}`);
};
